import { SearchStoreFormSX } from '@/components/content/StoreLocator/styles/StoreLocatorSearchStoreForm/searchStoreForm';
import DynamicIcon from '@/components/icons/DynamicIcon';
import { useLocalization } from '@/data/Localization';
import { Box, InputAdornment, TextField } from '@mui/material';
import { FormEvent, MouseEvent, useRef } from 'react';
import { MATERIAL_SYMBOL_ICONS } from 'shared/custom/constants/commonConstants';

type Props = {
	handleSubmit: (e: FormEvent<HTMLFormElement> | MouseEvent<HTMLDivElement>) => void;
	searchTerm: string;
	setSearchTerm: (s: string) => void;
	isSearch: boolean;
	goBackToList: () => void;
};

export const HeaderSearchStoreForm = ({
	handleSubmit,
	searchTerm,
	setSearchTerm,
	isSearch,
	goBackToList,
}: Props) => {
	const textInput = useRef<HTMLInputElement>();
	const localization = useLocalization('SearchStores');

	const handleOnFocus = () => {
		if (textInput.current?.value) textInput.current.value = '';
	};

	return (
		<form onSubmit={handleSubmit}>
			<Box>
				<TextField
					sx={SearchStoreFormSX.searchStoreInputContainer}
					placeholder={localization.searchStoreForm.t()}
					inputRef={textInput}
					onFocus={handleOnFocus}
					value={searchTerm}
					className="store-selector__search-store"
					onChange={(e) => {
						setSearchTerm(e.target.value);
					}}
					InputProps={{
						endAdornment: (
							<InputAdornment sx={SearchStoreFormSX.inputAdorment} position="end">
								{isSearch && (
									<span onClick={goBackToList}>
										<DynamicIcon name={MATERIAL_SYMBOL_ICONS.backspace} />
									</span>
								)}
								<Box
									sx={SearchStoreFormSX.iconContainer}
									className={isSearch ? 'was-search-icon' : ''}
									onClick={handleSubmit}
								>
									<DynamicIcon name={MATERIAL_SYMBOL_ICONS.search} />{' '}
								</Box>
							</InputAdornment>
						),
					}}
				/>
			</Box>
		</form>
	);
};
